import React from 'react';
import ThreeDButton from '../../3dButton';
import Distribution from './Distribution';
import Rendimientos from './Rendimientos';
import Movimientos from './Movimientos';
import AccountValue from './AccountValue';

const Conglomerate = () => {
  const [selectedTab, setSelectedTab] = React.useState('MisCDTs');
  const [selectedButton, setSelectedButton] = React.useState('Distribución');

  return (
    <div>
      <div className="bg-[#e8f2f4] pt-20 px-4 flex gap-2">
        {['MisCDTs', 'MisFICs', 'MiPensión'].map(tab => (
          <button
            key={tab}
            onClick={() => setSelectedTab(tab)}
            className={`py-2 px-6 font-bold rounded-t-md border-none ${selectedTab === tab ? 'bg-[#0346a4] text-white' : 'bg-[#ddedf0] text-[#0054c9]'}`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="bg-[#0346a4] p-8 min-h-[70vh] text-white">
        <div className="flex items-center justify-between mb-6">
          <div className="text-3xl font-bold text-white">Portafolio de cdts</div>
          <div className="flex gap-2">
            {['Distribución', 'Rendimientos', 'Movimientos', 'Valor cuenta'].map((label, idx) => (
              <ThreeDButton
                key={idx}
                text={label}
                selected={selectedButton === label}
                onClick={() => setSelectedButton(label)}
              />
            ))}
          </div>
        </div>

        {selectedButton === 'Rendimientos' ? (
          <Rendimientos />
        ) : selectedButton === 'Movimientos' ? (
          <Movimientos />
        ) : selectedButton === 'Valor cuenta' ? (
          <AccountValue
    
            totals={[
              { year: '2021', amount: 1200200 },
              { year: '2022', amount: 3003399 },
              { year: '2023', amount: 5435234 },
              { year: '2024', amount: 7356877 },
            ]}
          />
        ) : (
          <Distribution />
        )}
 
      </div>
    </div>
  );
};

export default Conglomerate;